import { toISODate } from "../../utils/date";

export const saleDefaults = {
    // 1. Contexto Operacional
    idMember: "", // Firestore doc.id de quem está comprando
    memberNumber: "", // Código sequencial amigável
    memberName: "", 
    memberPhone: "",
    memberEmail: "",
    idEmployee: "", // Vendedor
    employeeName: "", 

    date: toISODate(new Date()),

    // 2. Carrinho de Compras (Itens)
    items: [],
    // Exemplo de item do carrinho:
    // {
    //   idItem: "...",
    //   name: "Plano Anual",
    //   type: "membership", // "membership" | "product" | "evaluation" | "event"
    //   quantity: 1,
    //   unitPrice: 1200,
    //   totalPrice: 1200,
    //   discount: 0
    // }

    // 3. Totais Financeiros
    subtotal: 0,
    discountTotal: 0,
    totalAmount: 0,

    // 4. Fechamento e Pagamento (Como foi pago)
    paymentMethods: [],
    // Exemplo de split de pagamento:
    // {
    //   idMethod: "CREDIT_CARD",
    //   installments: 12, // Vezes
    //   amount: 1200
    // }

    // 5. Metadados do Cupom Utilizado (Gamification/Mkt)
    couponCode: "",
    couponDiscountValue: 0,

    // 6. Controle Administrativo
    status: "COMPLETED", // PENDING, COMPLETED, CANCELED, REFUNDED
    notes: "" // Anotação interna se precisa
};
